<template>
  <v-container>
    <div id="paypal-button-container"></div>
  </v-container>
</template>
<script>
export default {
  props: {
    amount: Number
  },
  data: function () {
    return {
      success: false,
      error: false
    }
  },
  mounted () {
    let membershipAmount = `${this.amount}`
    let Vue = this
    paypal.Buttons({
      style: {
        label: 'pay'
      },
      experienceOptions: {
        input_fields: {
          no_shipping: 1
        }
      },
      createOrder: function (data, actions) {
        console.log('PAYPAL CREATE ORDER TRIGGERED')
        console.log('Attempting New Order for $' + membershipAmount)
        return actions.order.create({
          purchase_units: [{
            amount: {
              value: membershipAmount
            }
          }]
        })
      },
      onApprove: function (data, actions) {
        // Capture the funds from the transaction
        return actions.order.capture().then(details => {
          // Show a success message to your buyer
          console.log('PAYPAL ON APPROVE TRIGGER')
          console.log(details)
          this.success = true
          this.error = false
          Vue.$emit('paypal-success', details)
        })
      },
      onCancel: function (data, actions) {
        console.log('PAYPAL CANCELLED')
      },
      onError: function (data, actions) {
        console.log('PAYPAL ERROR')
        console.log(data)
        Vue.$emit('paypal-error', data.message)
      }
    }).render('#paypal-button-container')
  }
}
</script>
<style>
#paypal-button-container .paypal-buttons{
  z-index: 2;
}
</style>
